export const SENIORITY_REQUIRED_TYPES = ["DOMAIN_SPECIFIC", "MOTIVATIONAL", "LEADERSHIP"];
export const COMPETENCY_MAPPING_TYPES = ["EXPERIENCE_BASED", "DOMAIN_SPECIFIC"];
export const FALLBACK_TYPES = [];

// The server labels every type it lists. This names a code that arrives without
// that list (a stored type it no longer lists, a job's selected types) the same
// way the server does: "DOMAIN_SPECIFIC" → "Domain Specific".
export const formatTypeLabel = (code) =>
  code
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
